/* Footer.jsx */
import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom"; // Add this import
import {
  Facebook,
  Instagram,
  Linkedin,
  Twitter,
  Phone,
  Mail,
} from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-slate-800 text-white px-6 py-10 rounded-t-2xl relative overflow-hidden">
      {/* Glassmorphism overlay */}
      <div className="absolute inset-0 bg-slate-800  border-t border-white/20"></div>

      <div className="relative z-10 max-w-7xl mx-auto grid md:grid-cols-3 gap-10">
        {/* Left Section */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl font-semibold mb-3 tracking-wide">
            EventPlanly
          </h2>
          <p className="text-gray-200/80 text-sm leading-relaxed mb-4">
            EventPlanly recommend you personally curated list of venue options
            by experts specially for your requirements.
          </p>
          <div className="flex items-center gap-2 mb-2 text-gray-200 hover:text-white transition-colors">
            <Mail size={18} />
            <span>info@itdesks.co</span>
          </div>
          <div className="flex items-center gap-2 text-gray-200 hover:text-white transition-colors">
            <Phone size={18} />
            <span>+1 (510) 520-7318</span>
          </div>
        </motion.div>

        {/* Quick Links */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2 }}
        >
          <h3 className="text-lg font-semibold mb-3">Quick Links</h3>
          <ul className="space-y-2 text-gray-300 text-sm">
            <li>
              <Link 
                to="/terms-and-conditions" 
                className="hover:text-white transition-colors cursor-pointer"
              >
                Terms and Conditions
              </Link>
            </li>
            <li>
              <Link 
                to="/privacy-policy" 
                className="hover:text-white transition-colors cursor-pointer"
              >
                Privacy Policy
              </Link>
            </li>
          </ul>
        </motion.div>

        {/* Contact Us */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.4 }}
        >
          <h3 className="text-lg font-semibold mb-3">Contact Us</h3>
          <p className="text-gray-200/80 text-sm hover:text-white transition-colors">
            info@itdesks.co
          </p>
          <p className="text-gray-200/80 text-sm hover:text-white transition-colors">
            +1 (510) 520-7318
          </p>
        </motion.div>
      </div>

      {/* Divider */}
      <div className="border-t border-gray-600/40 my-6 relative z-10"></div>

      {/* Bottom Section */}
      <div className="relative z-10 max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6">
        {/* Social Icons */}
        <div className="flex gap-4 text-xl">
          {[Facebook, Instagram, Linkedin, Twitter].map((Icon, i) => (
            <motion.a
              key={i}
              href="#"
              whileHover={{ scale: 1.2 }}
              whileTap={{ scale: 0.9 }}
              className="p-2 rounded-full bg-white/10 border border-white/20 hover:bg-white/20 transition-all"
            >
              <Icon size={20} />
            </motion.a>
          ))}
        </div>

        {/* Copyright */}
        <p className="text-gray-400 text-sm text-center">
          © EventPlanly — A Child Company of ITdesks. All rights reserved.
        </p>

        {/* Payment Icons */}
        <div className="flex gap-3">
          <motion.img
            whileHover={{ scale: 1.1 }}
            src="https://img.icons8.com/color/48/000000/apple-pay.png"
            alt="Apple Pay"
            className="h-8 rounded-lg bg-white p-1 border border-white/20 cursor-pointer"
          />
          <motion.img
            whileHover={{ scale: 1.1 }}
            src="https://img.icons8.com/color/48/000000/visa.png"
            alt="Visa"
            className="h-8 rounded-lg bg-white p-1 border border-white/20 cursor-pointer"
          />
          <motion.img
            whileHover={{ scale: 1.1 }}
            src="https://img.icons8.com/color/48/000000/mastercard.png"
            alt="Mastercard"
            className="h-8 rounded-lg bg-white p-1 border border-white/20 cursor-pointer"
          />
          <motion.img
            whileHover={{ scale: 1.1 }}
            src="https://img.icons8.com/color/48/000000/secured-letter--v2.png"
            alt="Secure Payment"
            className="h-8 rounded-lg bg-white p-1 border border-white/20 cursor-pointer"
          />
        </div>
      </div>
    </footer>
  );
};

export default Footer;